import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from './../../../templates/PageLayout/Popups/MessageBoxComponent.rt';

const mapStateToProps = (state) => {
  const {messageBoxComponent} = state.popups;
  return {
    ...messageBoxComponent
  }
}

class messageBoxComponent extends PureComponent {
  getAlertClassType = () => {
    return this.props.type || 'error';
  }

  getAlertColor = () => {
    switch (this.getAlertClassType()) {
      case "error":
        return "red";
      default:
        return "blue";
    }
  }

  render = template;
}

messageBoxComponent.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    subtext: PropTypes.string
  })),
  uibuttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    cls: PropTypes.string
  })),
  type: PropTypes.string
};

const MessageBoxComponent = connect(mapStateToProps)(messageBoxComponent);

export {MessageBoxComponent};

